import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { MethodOverview } from './components/MethodOverview';
import { MoreTestimonials } from './components/MoreTestimonials';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { EmotionalClose } from './components/EmotionalClose';
import { Pricing } from './components/Pricing';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-12 md:py-20 text-center pt-[4px] pb-[4px]" data-id="element-0">
    <p className="text-xl md:text-3xl font-display italic text-brand-darkGreen/85 leading-relaxed font-[800]" data-id="element-1">
      🌿 EL PROBLEMA NO ES LA CRISIS. EL PROBLEMA ES QUE TU CASA TODAVÍA NO ESTÁ
      LIMPIA.
    </p>
  </div>;
export function App() {
  return <div className="min-h-screen text-brand-text font-sans selection:bg-brand-goldLight/25 selection:text-brand-darkGreen bg-brand-surface" data-id="element-2">
      <UrgencyBanner data-id="element-3" />
      <Hero data-id="element-4" />
      <PainPoints data-id="element-5" />
      <MethodOverview data-id="element-6" />
      <MoreTestimonials data-id="element-7" />
      <CostComparison data-id="element-8" />
      <TransitionPhrase data-id="element-9" />
      <EmotionalClose data-id="element-10" />
      <FAQ data-id="element-11" />
      <Guarantee data-id="element-12" />
      <Footer data-id="element-13" />
    </div>;
}